export default __webpack_public_path__ + "static/media/stomachcare.3cf6c6be.png";